import React, { useState } from "react";
import { Row, Col, DatePicker, Button } from "antd";
import styles from "./Payment.module.scss";
import { RangePicker_Arrow } from "../../../assets/images";
import moment, { Moment } from "moment";
import { useBillingHistoryCtx } from "../../../context/BillingHistoryContext";
import { RangeValue } from "rc-picker/lib/interface";

const BillingHistoryDateRangePicker = () => {
  const [isPickerOpen, setIsPickerOpen] = useState<boolean>(false);
  const [datesSelected, setDatesSelected] = useState<boolean>(false);
  const [selectedDates, setSelectedDates] = useState<{
    startDate: string | undefined;
    endDate: string | undefined;
  }>();

  const { dateRangeCtx } = useBillingHistoryCtx();
  const [dateRange, setDateRange] = dateRangeCtx;

  const { RangePicker } = DatePicker;

  const handleSearchClick = () => {
    setDateRange(selectedDates || dateRange);
    setIsPickerOpen(false);
  };

  const handleBillingDateRange = (
    dates: RangeValue<Moment>,
    dateStrings: string[]
  ) => {
    if (dates) {
      const selectedBillingDateRange = {
        startDate: dates[0]?.local().format(),
        endDate: dates[1]?.local().format(),
      };
      setSelectedDates(selectedBillingDateRange);
      setDatesSelected(true);
    }
  };

  return (
    <RangePicker
      className={styles.customRangePicker}
      format="MM/DD/YY"
      allowClear={false}
      separator={<img src={RangePicker_Arrow} alt="range" />}
      defaultValue={[moment(dateRange.startDate), moment(dateRange.endDate)]}
      onChange={handleBillingDateRange}
      onOpenChange={(open) => {
        if (!datesSelected) {
          setIsPickerOpen(open);
        } else {
          setDatesSelected(false);
        }
      }}
      open={isPickerOpen}
      renderExtraFooter={() => (
        <Row justify="center">
          <Col>
            <Button onClick={handleSearchClick}>Search</Button>
          </Col>
        </Row>
      )}
    />
  );
};

export default BillingHistoryDateRangePicker;
